import { gql } from "@apollo/client";
import { UPDATE_STATUS_CACHE } from "../FindingDetailsPane/FindingDetailsPaneHeader/Statuses/ChangeStatus/UserStatusApi";
import { UPDATE_FINDING_TICKETS_CACHE } from "../../Ticketing/TicketingAPI";

export const GET_DATA_VALIDATION_FINDINGS = gql`
  query GetDataValidationFindings(
    $selected_instance_string_id: String
    $first: Int
    $after: String
    $before: String
    $last: Int
    $sort: [SortInput]
    $filters_config: FiltersConfigInput
    $with_total_count: Boolean!
  ) {
    silver_findings_view(
      first: $first
      after: $after
      before: $before
      last: $last
      sort: $sort
      filters_config: $filters_config
      datasource_id_str: $selected_instance_string_id
    ) {
      total_count @include(if: $with_total_count)
      edges {
        node {
          cloud_account_friendly_name
          cloud_account
          cloud_provider
          finding_id
          title
          source
          score
          severity
          raw_sql
          raw_result
          original_status
          original_score
          resource_id
          resource_type
          resource_name
          original_finding_id
          last_reported_time
          last_collected_time
          discovered_time
          rule_type
          rule_id
          finding_type_str
          package_name
          seemplicity_int_id
          seemplicity_status {
            key
            category
            type
            name
          }
          __typename
        }
      }
      __typename
    }
  }
`;

export const GET_FINDINGS = gql`
  ${UPDATE_STATUS_CACHE}
  ${UPDATE_FINDING_TICKETS_CACHE}
  query GetFindings(
    $first: Int
    $after: String
    $before: String
    $last: Int
    $sort: [FindingsViewSortEnum]
    $filters_config: FiltersConfigInput
    $with_total_count: Boolean!
    $with_original_severity: Boolean!
  ) {
    findings: remediation_items_view(
      first: $first
      after: $after
      before: $before
      last: $last
      sort: $sort
      filters_config: $filters_config
    ) {
      total_count @include(if: $with_total_count)
      edges {
        node {
          id
          id_int
          title
          score
          remediation_sub_phase
          severity
          original_severity @include(if: $with_original_severity)
          cloud_account
          cloud_account_friendly_name
          cloud_provider
          resource_name
          resource_type
          resource_count
          aggregated_findings_count
          open_aggregated_findings_count
          sla_status
          age
          datasource_tags_values
          discovered_time
          last_reported_time
          resolved_time
          category
          sub_category
          source
          seem_tags_values
          finding_type_str
          sla_remaining_time
          ...Tickets
          ...ActualStatus
          fix_id
          fix_vendor_id
          fix_type
          fix_subtype
          rule_type
          rule_family
          rule_id
          package_name
          mitigation_level
          ai_analyst_priority
          ai_analyst_priority_direction
          analyst_instance_id
        }
        cursor
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GET_FINDINGS_THIN_VIEW = gql`
  ${UPDATE_STATUS_CACHE}
  ${UPDATE_FINDING_TICKETS_CACHE}
  query GetFindings(
    $first: Int
    $after: String
    $before: String
    $last: Int
    $sort: [FindingsViewSortEnum]
    $filters_config: FiltersConfigInput
    $with_total_count: Boolean!
  ) {
    findings: remediation_items_view(
      first: $first
      after: $after
      before: $before
      last: $last
      sort: $sort
      filters_config: $filters_config
    ) {
      total_count @include(if: $with_total_count)
      edges {
        node {
          id
          id_int
          title
          score
          severity
          sla_status
          ...Tickets
          ...ActualStatus
          mitigation_level
        }
        cursor
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GET_FINDING_COUNTS = gql`
  query GetFindingCounts($filters_config: FiltersConfigInput) {
    findings: remediation_items_view_count(filters_config: $filters_config) {
      total_raw_count
      total_count
    }
  }
`;
